import { useState, useEffect, useRef } from 'react';
import { MDBBadge } from 'mdb-react-ui-kit';

import EditUser from './EditUser';

import {
    TableButton,
} from '../styles/AdminPageStyles';


export default function AdminTableRow({user, fetchRows}){

    const [userStatus, setUserStatus] = useState(user.status);
    const [userCreationDate, setUserCreationDate] = useState(user.account_created);
    const [userLastUpdated, setUserLastUpdated] = useState(user.last_updated)
    const [modalOpen, setModalOpen] = useState(false);
    const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 }); // State for modal position
    const editButtonRef = useRef(null);

    useEffect(() => {
        setUserStatus(user.status);
        setUserCreationDate(user.account_created);
        setUserLastUpdated(user.last_updated);
    }, [user.status, user.account_created, user.last_updated]);

    const updateModalPosition = () => {
        if (editButtonRef.current) {
            const rect = editButtonRef.current.getBoundingClientRect();
            const modalWidth = 210; // Set a fixed width for the modal (adjust as necessary)
            // Check if the screen width is 1025px or less
            if (window.innerWidth <= 1025) {
                // Position the modal to the left side of the button
                setModalPosition({
                    top: rect.top + window.scrollY - 40, // Align the modal top with the button top
                    left: rect.left + window.scrollX - modalWidth + 20 // Align to the left side of the button
                });
            } else {
                // Calculate the position to center the modal with respect to the button
                setModalPosition({
                    top: rect.bottom + window.scrollY, // Center vertically relative to the button
                    left: rect.left + window.scrollX + (rect.width / 2) - (modalWidth / 2) // Center horizontally relative to the button
                });
            }
        }
    };

    const status = () => {
        switch (userStatus) {
            case 'Active':
                return (
                    <MDBBadge color='success' pill>Active</MDBBadge>
                )
            case 'Awaiting Approval':
                return (
                    <MDBBadge color='warning' pill>Awaiting Approval</MDBBadge>
                )
            case 'Denied':
                return (
                    <MDBBadge color='danger' pill>Denied</MDBBadge>
                )
        }
    }

    const handleOpen = (e) => {
        e.stopPropagation();
        updateModalPosition();
        setModalOpen(!modalOpen);
    }

    useEffect(() => {
        const handleResize = () => {
            updateModalPosition(); // Update position on window resize
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize); // Clean up listener on unmount
        };
    });

    return (
        <tr>
            <td>
                <div className='d-flex align-items-center'>
                    <div className='ms-3'>
                        <p className='fw-bold mb-1'>{user.first_name} {user.last_name}</p>
                        <p className='text-muted mb-0'>{user.email}</p>
                    </div>
                </div>
            </td>
            <td>
                <p className='fw-normal mb-1'>{user.role}</p>
            </td>
            <td>
                <p className='fw-normal mb-1'>{user.email}</p>
            </td>
            <td>
                { user.phone_number ? <p className='fw-normal mb-1'>{user.phone_number}</p> : <p className='fw-normal mb-1'>-</p> }
            </td>
            <td>
                {status()}
            </td>
            <td>
                {user.account_created ? (
                    <p className='fw-normal mb-1'>{user.account_created}</p>
                ) : (
                    <p className='fw-normal mb-1'>-</p>
                )}
            </td>
            <td>
                {user.account_created ? (
                    <p className='fw-normal mb-1'>{user.last_updated}</p>
                ) : (
                    <p className='fw-normal mb-1'>-</p>
                )}
            </td>
            <td>
                <TableButton onClick={(e) => handleOpen(e)} ref={editButtonRef}>Edit</TableButton>
                {modalOpen && <EditUser 
                                user={user} 
                                setModalOpen={setModalOpen}
                                position={modalPosition}
                                fetchRows={fetchRows} />}
            </td>
        </tr>
    )
}